"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageEffectHandler = exports.DamageEffectArgs = void 0;
const __1 = require("../../..");
const Damage_1 = require("../../Damage");
const Duration_1 = require("../../Duration");
const AttributeType_1 = require("../../enums/AttributeType");
const DamageType_1 = require("../../enums/DamageType");
const core_1 = require("../../events/core");
const Damaged_1 = require("../../events/core/Damaged");
const DamageTypeToDamagePercentIncrease_1 = require("../../maps/DamageTypeToDamagePercentIncrease");
const DamageTypeToDamageResistance_1 = require("../../maps/DamageTypeToDamageResistance");
const DamageTypeToImmunity_1 = require("../../maps/DamageTypeToImmunity");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const Death_1 = require("./Death");
class DamageEffectArgs {
    constructor(damage, fromCrit, fromDoT) {
        this.damage = damage;
        this.fromCrit = fromCrit;
        this.fromDoT = fromDoT;
        this.__type = EffectType_1.EffectType.Damage;
        this.__typeName = "Damage";
        this.name = "Damage";
        this.harmful = true;
    }
    static fromExactAmount(container, damageType, attackerId, targetId, amount) {
        const [absoluteAllImmunity, absoluteTypeImmunity,] = container.getAttributeScores(targetId, [
            AttributeType_1.AttributeType.AbsoluteAllDamageImmunity,
            DamageTypeToImmunity_1.DamageTypeToAbsoluteImmunity[damageType],
        ]);
        const absoluteImmunity = Math.min(100, absoluteAllImmunity + absoluteTypeImmunity);
        if (absoluteImmunity > 0) {
            amount = Math.round(amount * absoluteImmunity * .01);
        }
        return new DamageEffectArgs(new Damage_1.Damage(damageType, amount), false, false);
    }
    static fromDoT(container, dotType, damageType, attackerId, targetId, offensiveAttr, defensiveAttr, dotPower, isCriticalHit) {
        const attackLevel = container.getLevel(attackerId);
        const [offensiveAttrValue, criticalIncrease, typeIncrease, dotIncrease] = container.getAttributeScores(attackerId, [
            offensiveAttr,
            AttributeType_1.AttributeType.CriticalDamageMultiplier,
            DamageTypeToDamagePercentIncrease_1.DamageTypeToDamagePercentIncrease[damageType],
            __1.DoTTypeToPercentIncrease[dotType],
        ]);
        const percentIncrease = .01 * Math.max(-100, typeIncrease + dotIncrease);
        const [defensiveAttribute, criticalReduction, typeImmunity, dotImmunity, absoluteAllImmunity, absoluteTypeImmunity, typeResistance] = container.getAttributeScores(targetId, [
            defensiveAttr,
            AttributeType_1.AttributeType.CriticalDamageReductionPercent,
            DamageTypeToImmunity_1.DamageTypeToImmunity[damageType],
            __1.DoTTypeToImmunity[dotType],
            AttributeType_1.AttributeType.AbsoluteAllDamageImmunity,
            DamageTypeToImmunity_1.DamageTypeToAbsoluteImmunity[damageType],
            DamageTypeToDamageResistance_1.DamageTypeToDamageResistance[damageType],
        ]);
        const totalResistance = Math.round(typeResistance);
        const percentImmunity = .01 * Math.max(Math.min(100, absoluteAllImmunity + absoluteTypeImmunity), Math.min(50, Math.min(40, typeImmunity) + dotImmunity));
        const ATTR_MULT = Math.max(0, offensiveAttrValue / Math.max(1, .5 * defensiveAttribute));
        const CRIT_MULT_BASE = Math.max(0, criticalIncrease - criticalReduction);
        const CRIT_MULT = isCriticalHit ? (1 + CRIT_MULT_BASE * .01)
            : 1;
        const LEVEL_ADJUST = (2 + attackLevel * 2 * CRIT_MULT * .2);
        const INCREASE_IMMUNITY_MULT = (1 + percentIncrease) * (1 - percentImmunity);
        const ROLL = (0, __1.roundTo)((0, __1.random)(850, 1000) / 1000, 3);
        const BASE_DMG = ROLL * .025 * ATTR_MULT * LEVEL_ADJUST * 2 * dotPower;
        const AFTER_RESIST = Math.max(0, BASE_DMG - totalResistance);
        const DMG_OUT = Math.round(INCREASE_IMMUNITY_MULT * AFTER_RESIST);
        // console.info(`DOT_DAMAGE, ATTR_MULT=${ATTR_MULT}, CRIT_MULT=${CRIT_MULT}, LEVEL_ADJUST=${LEVEL_ADJUST}, INCREASE_IMMUNITY_MULT=${INCREASE_IMMUNITY_MULT}, ROLL=${ROLL}, BASE_DMG=${BASE_DMG}, totalResistance=${totalResistance}, AFTER_RESIST=${AFTER_RESIST}, DMG_OUT=${DMG_OUT}`)
        return new DamageEffectArgs(new Damage_1.Damage(damageType, DMG_OUT), isCriticalHit, true);
    }
    static fromAttack(container, damageType, attackerId, targetId, offensiveAttr, defensiveAttr, abilityPower, isCriticalHit) {
        const attackLevel = container.getLevel(attackerId);
        const [offensiveAttrValue, criticalIncrease, allIncrease, typeIncrease,] = container.getAttributeScores(attackerId, [
            offensiveAttr,
            AttributeType_1.AttributeType.CriticalDamageMultiplier,
            AttributeType_1.AttributeType.AllDamagePercentIncrease,
            DamageTypeToDamagePercentIncrease_1.DamageTypeToDamagePercentIncrease[damageType],
        ]);
        const percentIncrease = .01 * Math.max(-100, allIncrease + typeIncrease);
        const [defensiveAttribute, criticalReduction, allImmunity, typeImmunity, absoluteAllImmunity, absoluteTypeImmunity, allResistance, typeResistance] = container.getAttributeScores(targetId, [
            defensiveAttr,
            AttributeType_1.AttributeType.CriticalDamageReductionPercent,
            AttributeType_1.AttributeType.AllDamageImmunity,
            DamageTypeToImmunity_1.DamageTypeToImmunity[damageType],
            AttributeType_1.AttributeType.AbsoluteAllDamageImmunity,
            DamageTypeToImmunity_1.DamageTypeToAbsoluteImmunity[damageType],
            AttributeType_1.AttributeType.AllDamageResistance,
            DamageTypeToDamageResistance_1.DamageTypeToDamageResistance[damageType]
        ]);
        const totalResistance = Math.round(allResistance + typeResistance);
        const percentImmunity = .01 * Math.max(Math.min(100, absoluteAllImmunity + absoluteTypeImmunity), Math.min(50, Math.min(40, allImmunity) + typeImmunity));
        // =MAX(0, (1 + DMG% * 0.01) * POWorFOC / MAX(1, 0.5 * TOU))
        // =2 + LVL * 2 * CRIT_MULT * 0.2 
        // =FLOOR(0.025 * MAX(0, (1 + DMG% * 0.01) * POWorFOC / MAX(1, 0.5 * TOU)) * (2 + LVL * 2 * (1 + CRIT_MULT * 0.01) * 0.2) * 2 * ABILITY_POWER)
        // =FLOOR(0.025 * MAX(0, (1 + DMG% * 0.01) * POWorFOC / MAX(1, 0.5 * TOU)) * (2 + LVL * 2 * (1 + CRIT_MULT * 0.01) * 0.2) * 2 * ABILITY_POWER)
        // =FLOOR(0.025 * MAX(0, (1 + DMG% * 0.01) * POWorFOC / MAX(1, 0.5 * TOU)) * (2 + LVL * 2 * CRIT_MULT * 0.2) * 2 * ABILITY_POWER)
        // =FLOOR((1 + DMG% * 0.01) * ROLL * 0.025 * MAX(0, POWorFOC / MAX(1, 0.5 * TOU) * (2 + LVL * 2 * CRIT_MULT * 0.2) * 2) * ABILITY_POWER)
        const ATTR_MULT = Math.max(0, offensiveAttrValue / Math.max(1, .5 * defensiveAttribute));
        const CRIT_MULT_BASE = Math.max(0, criticalIncrease - criticalReduction);
        const CRIT_MULT = isCriticalHit ? (1 + CRIT_MULT_BASE * .01)
            : 1;
        const LEVEL_ADJUST = (2 + attackLevel * 2 * CRIT_MULT * .2);
        const INCREASE_IMMUNITY_MULT = (1 + percentIncrease) * (1 - percentImmunity);
        const ROLL = (0, __1.roundTo)((0, __1.random)(850, 1000) / 1000, 3);
        const BASE_DMG = ROLL * .025 * ATTR_MULT * LEVEL_ADJUST * 2 * abilityPower;
        const AFTER_RESIST = Math.max(0, BASE_DMG - totalResistance);
        const DMG_OUT = Math.round(INCREASE_IMMUNITY_MULT * AFTER_RESIST);
        // console.info(`ATTACK_DAMAGE, ATTR_MULT=${ATTR_MULT}, CRIT_MULT=${CRIT_MULT}, LEVEL_ADJUST=${LEVEL_ADJUST}, percentIncrease=${percentIncrease}, percentImmunity=${percentImmunity}, INCREASE_IMMUNITY_MULT=${INCREASE_IMMUNITY_MULT}, ROLL=${ROLL}, BASE_DMG=${BASE_DMG}, totalResistance=${totalResistance}, AFTER_RESIST=${AFTER_RESIST}, DMG_OUT=${DMG_OUT}`)
        return new DamageEffectArgs(new Damage_1.Damage(damageType, DMG_OUT), isCriticalHit, false);
    }
}
exports.DamageEffectArgs = DamageEffectArgs;
let DamageEffectHandler = class DamageEffectHandler {
    apply(sequence, container, state) {
        state.meta.absorbed = 0;
        if (state.args.damage.amount <= 0) {
            return;
        }
        else if (state.args.damage.type === DamageType_1.DamageType.None) {
            return;
        }
        else if (container.hasEffectOfType(state.targetId, EffectType_1.EffectType.Invulnerable)) {
            return;
        }
        const [healthBefore] = container.getAttributeScores(state.targetId, [
            AttributeType_1.AttributeType.Health
        ]);
        if (healthBefore <= 0) {
            return;
        }
        let amount = state.args.damage.amount;
        const absorbSequence = sequence.pushSequence("parallel");
        const absorbIds = container.getEffectsOfType(state.targetId, EffectType_1.EffectType.DamageAbsorb).slice();
        for (const absorbId of absorbIds) {
            const absorbEffect = container.getEffect(absorbId);
            const meta = absorbEffect.meta;
            const absorbAmount = (0, __1.getValueOrDefaultTo)(meta.absorbsByDamageType, state.args.damage.type, 0)
                + (0, __1.getValueOrDefaultTo)(meta.absorbsByDamageType, DamageType_1.DamageType.All, 0);
            if (absorbAmount === 0) {
                continue;
            }
            const remainingAbsorb = Math.min(meta.remainingAbsorb, absorbAmount);
            const consumed = Math.min(amount, remainingAbsorb);
            meta.remainingAbsorb -= consumed;
            meta.absorbsByDamageType[state.args.damage.type] -= consumed;
            if (amount >= remainingAbsorb) {
                container.cancelEffect(absorbSequence, absorbId);
            }
            state.meta.absorbed += meta.remainingAbsorb;
            amount = amount - consumed;
            container.applyFloatingText(sequence, state.targetId, `(${consumed}) Absorbed`, __1.DamageTypeToColor[state.args.damage.type], "small");
            container.applyBattleLogText(sequence, state.targetId, `(${consumed}) Absorbed`, __1.DamageTypeToColor[state.args.damage.type]);
            container.emitEvent(absorbSequence, state.targetId, new __1.DamageAbsorbedEventArgs(state.creatorId, new Damage_1.Damage(state.args.damage.type, consumed)));
        }
        amount = Math.max(0, Math.round(amount));
        state.args.damage = new Damage_1.Damage(state.args.damage.type, amount);
        state.meta.applied = new Damage_1.Damage(state.args.damage.type, amount); // TODO: remove...
        if (amount <= 0) {
            return;
        }
        const preDeathSequence = sequence.pushSequence("parallel");
        container.setHealth(preDeathSequence, state.targetId, healthBefore - amount);
        const targetIsNowDeceased = container.getAttributeScore(state.targetId, AttributeType_1.AttributeType.Health) <= 0;
        preDeathSequence.push(__1.FloatingTextVfxStepArgs.fromDamage(state.targetId, state.args.damage, state.args.fromCrit, "random"), __1.BattleLogEntryVfxStepArgs.fromDamages(container, state.creatorId, state.targetId, state.args.fromCrit, [state.args.damage]));
        container.emitEvent(preDeathSequence, state.targetId, new Damaged_1.DamagedEventArgs(state.creatorId, state.args.damage, state.args.fromCrit, state.args.fromDoT));
        container.emitEvent(preDeathSequence, state.creatorId, new core_1.DamageDealtEventArgs(state.targetId, state.args.damage, state.args.fromCrit, state.args.fromDoT));
        if (targetIsNowDeceased) {
            container.applyEffect(sequence, state.creatorId, state.targetId, new Death_1.DeathEffectArgs(), Duration_1.Duration.Permanent, false);
        }
    }
    remove(sequence, container, state) {
        // TODO: Do we support this?
    }
};
DamageEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Damage)
], DamageEffectHandler);
exports.DamageEffectHandler = DamageEffectHandler;
